import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Typography,
    Box,
    Button,
    CircularProgress,
    Chip,
    Stack,
    Paper
} from "../ui";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  test_environment_mode
} from "../../constants/constant";

const Recharge = () => {
  const [loading, setLoading] = useState(true);
  const [balanceData, setBalanceData] = useState(null);
  const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
  const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);

  const fetchBalance = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${storeApiUrl.BACKEND_BASE_URL}/get-payment-config?clientId=${storeActiveShopHash.id}&jobId=4`
      );

      if (res?.data?.status === 200) {
        setBalanceData(res.data.payLoad.packDetails);
      }
    } catch (err) {
      console.error("Failed to fetch balance", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
 fetchBalance();
  }, []);


  const handleRecharge = () => {
    const payload = {
        serviceUrlType: 2,
        rechargeType: 4,
        clientId: storeActiveShopHash.id,
        ts: Math.floor(Date.now() / 1000),
        paymentJobLabel: "Whatsapp Recharge",
        redirectUrl: window.location.origin 
      };

    const encoded = btoa(JSON.stringify(payload));

    const url = `https://payment.snpnextgen.com/recharge?data=${encoded}`;
    const localUrl = `http://localhost:3001/recharge?data=${encoded}`;
    window.open(url, "_blank");
  };

  const balance = balanceData?.balance ?? 0;


    return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: 360,
          p: 4,
          borderRadius: 3,
          textAlign: "center"
        }}
      >
        {loading ? (
          <Box py={4}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <Stack spacing={2} alignItems="center">
            {/* Title */}
            <Typography variant="h4" fontWeight={600}>
              Whatsapp Notification
            </Typography>

            {/* Balance */}
            <Typography
              variant="h6"
              fontWeight={600}
              color={balanceData?.balance <= 10 ? "error.main" : "text.primary"}
            >
              Remaining Balance: {balanceData?.balance}
            </Typography>

            {/* Service */}
            <Typography variant="body2" color="text.secondary">
              {balanceData?.serviceName }
            </Typography>

            {/* Low Balance */}
            {balance <= 10 && (
              <Chip
                label="Low Balance"
                color="error"
                size="small"
              />
            )}

            {/* CTA */}
            <Button
              variant="contained"
              onClick={handleRecharge}
              fullWidth
              disabled={!balanceData}
              sx={{
                mt: 1,
                py: 1.2,
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600
              }}
            >
              Recharge Now
            </Button>
          </Stack>
        )}
      </Paper>
    </Box>
  );
};

export default Recharge;

